var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showLiftSummary)?_c('flip-quick-stats',{staticClass:"quick-stat",attrs:{"stats":_vm.summaryStatsWithAdditionalPayload,"window-type":_vm.windowType,"loading":_vm.loading || _vm.isLoading,"show-diff-pill":_vm.dates.compareWith && _vm.windowType !== _vm.WINDOW_TYPE_LIFT,"show-diff-pill-with-background":_vm.showDiffPillWithBackground}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }